import { ModuleWithProviders, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { LoaderService } from './loader.service';
import { LoaderComponent } from './loader.component';
import { LoaderInterceptor } from './loader.interceptor';

// `LoaderService` é `providedIn: 'root'` e não é declarado aqui de propósito:
// re-provê-lo criaria uma instância por módulo lazy que importasse este módulo,
// e aí o contador de requisições, a janela de interação e os listeners de gesto
// ficariam divididos entre instâncias — o overlay simplesmente não apareceria.
@NgModule({
  imports: [CommonModule],
  exports: [LoaderComponent],
  declarations: [LoaderComponent],
})
export class RsmLoaderModule {
  static forRoot(): ModuleWithProviders<RsmLoaderModule> {
    return {
      ngModule: RsmLoaderModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: LoaderInterceptor,
          multi: true,
        },
      ],
    };
  }
}
